/* eslint-disable */
// THIS FILE WAS GENERATED BY TRANSLATIONS-CLI ON Thu Apr 30 2020 19:30:13 GMT+0100 (Western European Summer Time) 
// DO NOT MODIFY DIRECTLY.
 
export default {
  "common": {
    "base_url": "https://loandolphin.com.au",
    "error": {
      "are_you_lost": "你失去了什麼？",
      "back_home": "帶我回家",
      "enquiry_not_found": "詢問沒有找到！",
      "generic": "哎呀！發生錯誤。請稍後再試。",
      "not_found": "網頁未找到！",
      "oops": "哎呀",
      "recaptcha": "對不起，你似乎是一個機器人。如果你是一個真正的人，請重試。"
    },
    "external_route": {
      "about_us": "關於我們",
      "blog": "博客",
      "calculators": "計算器",
      "contact": "聯繫我們",
      "faq": "常見問題解答",
      "home": "loandolphin.com.au",
      "need_help": "需要幫忙？",
      "terms": "條款和條件"
    },
    "footer": {
      "address": "地址",
      "broker_associations": "與註冊",
      "copyright": "LoanDolphin©2019",
      "licence": "澳大利亞信貸許可證編號：500703",
      "main_1": "我們不是一個信貸提供者，在給您的產品信息，我們不會做任何意見或建議給大家介紹一個特定的產品。",
      "main_2": "如果您決定申請產品，你會與金融機構或經紀人，而不是與LoanDolphin直接處理。",
      "main_3": "產品信息應與相關供應商（銀行貸款和經紀人）得到確認，而你應該檢查PDS（連接到你的報價），然後再做出決定。",
      "main_4": "這個建議是一般性質的，並沒有考慮到你的目標，財務狀況或需要。",
      "main_5": "考慮這個建議是否適合你。",
      "subscribe": {
        "action": "訂閱",
        "error": "出問題了！請稍後再試。",
        "label": "訂閱我們的新聞",
        "success": "我們已經通過電子郵件發送你一個鏈接，確認您的訂閱。通過點擊我們的電子郵件中的鏈接，請證實。"
      }
    },
    "header": {
      "about_us": "關於我們",
      "blog": "博客",
      "calculators": "計算器",
      "contact": "聯繫",
      "get_started": "入門",
      "home": "家",
      "how_it_works": "怎麼運行的",
      "login": "登錄"
    },
    "label": {
      "today": "今天"
    },
    "week_days": {
      "full": {
        "friday": "星期五",
        "monday": "星期一",
        "saturday": "星期六",
        "sunday": "星期日",
        "thursday": "星期四",
        "tuesday": "星期二",
        "wednesday": "星期三"
      },
      "short": {
        "friday": "週五",
        "monday": "週一",
        "saturday": "星期六",
        "sunday": "太陽",
        "thursday": "星期四",
        "tuesday": "星期二",
        "wednesday": "星期三"
      }
    }
  },
  "home": {
    "awards": {
      "title": "我們的提名獎"
    },
    "contact": {
      "action": "發信息",
      "email": "電子郵件",
      "error": "很抱歉，我們沒能proccess你在這個時候請求。請確認您的信息或稍後再試。",
      "message": "信息",
      "name": "名稱",
      "recaptcha": "請勾選框繼續",
      "subject": "話題",
      "success_1": "感謝您聯繫LoanDolphin。",
      "success_2": "您的請求將被盡快我們的團隊成員之一跟進。",
      "success_3": "請確保您的垃圾郵件過濾器設置為接受來自loandolphin.com.au消息。",
      "title": "想與我們取得聯繫？",
      "error_email": "請輸入有效電子郵件。",
      "error_required": "這是必填欄。"
    },
    "hero": {
      "subtitle": "一個用於smartgroup的工作的額外補貼是可以節省的錢呢！關注銀行和抵押貸款經紀人通過我們與合作夥伴LoanDolphin競爭為您的家庭貸款！",
      "title": "你幫客戶省錢，現在我們幫你"
    },
    "demo": {
      "disclaimer": "*僅出於說明目的，不是真正的優惠"
    },
    "lenders": {
      "title": "有些我們可以訪問許多貸款人"
    },
    "numbers": {
      "average_score": {
        "description_1": "從平均分",
        "description_2": "產品審核",
        "title": "4.9 / 5"
      },
      "average_time": {
        "description_1": "平均節省時間",
        "description_2": "每個客戶",
        "title": "8小時"
      },
      "investment_loans": {
        "description_1": "利率",
        "description_2": "投資貸款",
        "prepend": "低至",
        "title": "2.99％"
      },
      "owner_loans": {
        "description_1": "利率",
        "description_2": "自住貸款",
        "prepend": "低至",
        "title": "2.79％"
      },
      "title": "你可以信任號碼"
    },
    "outdated_browser": {
      "action": {
        "acknowledge": "得到它了！",
        "new_browser": "獲取一個新的瀏覽器"
      },
      "modal": {
        "greeting": "嗨那裡，水手！",
        "message": "您正在瀏覽未知的水域，目前不支持您的瀏覽器。請務必使用邊緣，瀏覽器，Firefox或Safari瀏覽器的一些一帆風順，否則，你會提前遇到一些暴風雨天氣和我們的平台可能無法按預期方式工作。",
        "title": "警告"
      }
    },
    "reasons": {
      "description": "我們努力為客戶提供澳大利亞最好的數字家庭貸款服務。我們的重點是你的，我們希望幫助您和您可以最終打造為所有澳大利亞人公平和透明的金融市場上最好的交易連接。這是我們的核心價值觀。",
      "fair_and_open": {
        "description": "不同於其他網站，我們不收取銀行和經紀公司任何加盟或按月收費。每個人都是免費為您的家庭貸款競爭。",
        "title": "公平與公開"
      },
      "free": {
        "description": "我們可以保持免費的服務歸功於我們吸引借款人誰是認真的再融資或尋求通過我們獨特的服務，新的購房按揭選擇的能力。",
        "title": "100％免費"
      },
      "no_obligation": {
        "description": "沒有承諾，你是不是鎖定直至貸款了事。你選擇什麼是適合你的。",
        "title": "沒有義務"
      },
      "quality": {
        "description": "每個經紀人和貸款人正在接受我們的批准之前篩選。他們還審議並通過客戶定期評級。",
        "title": "質量有保證的"
      },
      "save_time": {
        "description": "當銀行和經紀公司競爭，您提供更好的住房貸款在較短時間內取得勝利。",
        "title": "節省時間和金錢"
      },
      "secure": {
        "description": "我們使用銀行級的安全技術，並允許您控制誰可以看到您的信息。",
        "title": "私密性和安全"
      },
      "title": "為什麼你會愛上我們"
    },
    "title": {
      "main": "LoanDolphin和smartgroup的"
    },
    "tutorial": {
      "label": {
        "video": "觀看一段簡短的一分鐘視頻"
      },
      "step_1": {
        "description": "通過填寫我們的調查形式，您告訴我們您的優先事項和財務需求開始。只需要四分鐘，我們向你保證，所有這些細節將保持安全和私人在我們的平台。",
        "title": "1"
      },
      "step_2": {
        "description": "這就像一個拍賣，但你拿著錘子。我們核實貸款人相互競爭，給你在市場上最好的交易。現在，你只需要選擇，知道你有所有的信息和控制，始終以飽滿的透明度。",
        "title": "2"
      },
      "step_3": {
        "description": "一旦你感到快樂，你會與你所選擇的貸款人或經紀人誰都會支持你通過你的應用程序連接。",
        "title": "3"
      },
      "step_4": {
        "description": "您可以檢查過程和更新，隨時隨地。我們，LoanDolphin，將永遠伴隨著你的每一步，後退一步並享受乘坐。",
        "title": "4"
      },
      "title": "它是如何工作的？"
    },
    "reviews": {
      "title": "為什麼我們這樣做",
      "review_link_title": "回顧鏈接",
      "review1": {
        "content": "LoanDolphin超出我們的預期。這項服務是如此專業和包容。他們發現我們的超級競爭力的價格，我們無法找到其他地方。",
        "author": "安妮樂騎士"
      },
      "review2": {
        "content": "大力支持下，迅速作出反應。我在一個小時內有我的第一次報價。經紀公司的評論和體驗的評分允許判斷今後的活動的質量。",
        "author": "喬治"
      },
      "review3": {
        "content": "一流的服務。得到了很多優惠，從並與如果需要進一步調查選擇。目前工程進展看起來有前途的應用程序，它應該救我，每年成本的合理費用。",
        "author": "格雷格"
      },
      "review4": {
        "content": "從球隊在LoanDolphin接受服務，我的水平非常好。他們將獲得在同一天回到我的問題。我感到舒服的每一步。我強烈推薦這個平台給任何人。",
        "author": "馬特ķ"
      },
      "review5": {
        "content": "LoanDolphin在幫助我們找到一個更好的交易，當我們決定再融資，我們的房屋貸款非常有幫助。他們的平台是易於使用，並把我們的聯繫方式，一些偉大的優惠。",
        "author": "邁克爾大號"
      },
      "review6": {
        "content": "我強烈推薦這個平台，那些希望得到一個新的房屋貸款再融資或。 LoanDolphin已經幫我節省了很多時間，希望很多錢。",
        "author": "生硬的"
      },
      "review7": {
        "content": "貸款海豚是非常迅速用合適的抵押貸款經紀人和我們相比。由抵押貸款經紀人提供的服務是非常專業和友好的。他們去超越讓我們一個很大的購買我們的第一個家。",
        "author": "彌敦道中號"
      }
    },
    "story": {
      "title": "我們的業務背後的故事",
      "paragraph_1": "LoanDolphin出生的時候創辦Ranin門迪斯和Rod杜特拉滿足於“四大”銀行工作一段時間。他們看到的麻煩和挫折的客戶以最優惠價格保證合適的貸款往往經歷。他們知道必須有一個更好的辦法。使這一過程透明的一種方式，公平，確保客戶收到的方便獲取合適的貸款。",
      "paragraph_2": "LoanDolphin是唯一真正以客戶為中心的數字化貸款服務，幫助您獲得比廣告上的利率降低。我們不與任何一家銀行或抵押貸款經紀人和下屬保持專注於為所有澳大利亞人一個透明的金融市場。"
    },
    "alternate": {
      "accesspay": {
        "title": "在感謝AccessPay短短幾分鐘內在線獲得貸款的健康檢查",
        "subtitle": "其中之一是一個AccessPay客戶的津貼是，你可以節省的錢你的抵押貸款呢！關注銀行和抵押貸款經紀人通過我們與合作夥伴LoanDolphin競爭為您的家庭貸款！"
      },
      "advantage": {
        "title": "在感謝優勢短短幾分鐘內在線獲得貸款的健康檢查",
        "subtitle": "其中之一是一個優勢工資包裝客戶的特殊待遇的是，你可以節省的錢你的抵押貸款呢！關注銀行和抵押貸款經紀人通過我們與合作夥伴LoanDolphin競爭為您的家庭貸款！"
      },
      "smartsalary": {
        "title": "在感謝Smartsalary短短幾分鐘內在線獲得貸款的健康檢查",
        "subtitle": "其中之一是一個Smartsalary客戶的津貼是，你可以節省的錢你的抵押貸款呢！關注銀行和抵押貸款經紀人通過我們與合作夥伴LoanDolphin競爭為您的家庭貸款！"
      },
      "autopia": {
        "title": "在拜馳短短幾分鐘內在線獲得貸款的健康檢查",
        "subtitle": "其中之一是一個馳客戶的津貼是，你可以節省的錢你的抵押貸款呢！關注銀行和抵押貸款經紀人通過我們與合作夥伴LoanDolphin競爭為您的家庭貸款！"
      },
      "smartleasing": {
        "title": "在感謝Smartleasing短短幾分鐘內在線獲得貸款的健康檢查",
        "subtitle": "其中之一是一個Smartleasing客戶的津貼是，你可以節省的錢你的抵押貸款呢！關注銀行和抵押貸款經紀人通過我們與合作夥伴LoanDolphin競爭為您的家庭貸款！"
      },
      "selectus": {
        "title": "在感謝Selectus短短幾分鐘內在線獲得貸款的健康檢查",
        "subtitle": "其中之一是一個Selectus客戶的津貼是，你可以節省的錢你的抵押貸款呢！關注銀行和抵押貸款經紀人通過我們與合作夥伴LoanDolphin競爭為您的家庭貸款！"
      }
    }
  }
}